import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { NptPanel } from "./NptPanel";

/**
 * Time log / NPT screen — the standalone route. Resolves the current well's
 * active event and renders the NPT roll-up panel (also embedded in the DDR
 * Time/NPT tab).
 */
export function TimeNpt() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("npt.title")}</h1>
        <p className="subtitle">{well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}</p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? <NptPanel eventId={activeEvent.id} /> : null}
      </QueryState>
    </div>
  );
}
